import React, { useState, useEffect, useContext } from "react";
import "./styles.css";
import ReactQuillEditor from "../../../components/reactQuillEditor";
import { TextField, Tooltip } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateFormat } from "../../../lib/functions";
import { createNotes, getNotes, updateNotes } from "../../../actions/configuration";
import { PayLoadCtx } from "../../../lib/context";
import Loader from "../../../lib/ui/loader/Loader";
import { toast } from "react-toastify";
import { Button } from "@material-ui/core";
import {API} from 'aws-amplify';

const InternalNote = ({ inNotes, close, data }) => {
    const { payload } = useContext(PayLoadCtx);
    const [editBtn, setEditBtn] = useState(false);
    const [editNotes, setEditNotes] = useState(false);
    const [notes, SetNotes] = useState({
        id: "",
        name: data?.patientData?.name,
        meetId: data?.patientData?.consultId,
        dob: data?.patientData?.dob,
        place: "",
        notes: "",
        get: false,
    });
    const [cancel, setCancel] = useState({
        name: data?.patientData?.name,
        dob: data?.patientData?.dob,
        place: "",
    });
    const [loading, setLoading] = useState(false);

    const handleget = () => {
        setLoading(true);
        let query = `?did=${data?.doctorId}&aid=${data?.appointmentId}`;
        getNotes(query)
            .then((res) => {
                if (res?.status && res?.data) {
                    let pdob = res?.data?.pdob;
                    let pdobNumber = Number(pdob);
                    let result = isNaN(pdobNumber) ? pdob : pdobNumber;

                    SetNotes({
                        id: res?.data?._id,
                        name: res?.data?.pname,
                        dob: result,
                        meetId: res?.data?.meetingId,
                        place: res?.data?.place || "",
                        notes: res?.data?.notes || "",
                    });
                    setEditNotes(true);
                    setCancel({
                        name: res?.data?.pname,
                        dob: res?.data?.pdob,
                        place: res?.data?.place || "",
                    });
                }
                setLoading(false);
            })
            .catch((e) => {
                console.log("e.........:", e);
                if(API.isCancel(e)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        if (notes?.id === "" || notes?.get === true) {
            handleget();
        }
    }, [notes?.get]);

    const parseDate = (date) => {
        if (!date) return "";
        const parsedDate = new Date(Number(date) || date);
        return parsedDate.toLocaleDateString('en-IN');
    };
    
    const formattedDate = parseDate(notes?.dob);

    const handleSubmitData = async () => {
        setLoading(true);
        if (notes?.id === "") {
            let createbody = {
                doctorId: data?.doctorId,
                appointmentId: data?.appointmentId,
                clinicId: data?.clinicId,
                patientId: data?.patientId,
                subdomain: payload?.subdomain,
                meetingId: data?.patientData?.consultId,
            };
            notes?.notes && notes?.notes !== "" && (createbody["notes"] = notes?.notes);
            notes?.name && notes?.name !== "" && (createbody["pname"] = notes?.name);
            notes?.dob && notes?.dob !== "" && (createbody["pdob"] = notes?.dob);
            notes?.place && notes?.place !== "" && (createbody["place"] = notes?.place);

            createNotes(createbody)
                .then((res) => {
                    if (res?.status) {
                        toast.success(res?.data, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        SetNotes({ ...notes, get: true });
                        setEditNotes(true);
                    } else {
                        toast.error(res?.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    console.log("e.........:", e);
                    setLoading(false);
                    setEditNotes(false);
                });
                close();
        } else {
            let updatebody = {
                dId: data?.doctorId,
                id: notes?.id,
            };

            notes?.notes && notes?.notes !== "" && (updatebody["notes"] = notes?.notes);
            notes?.name && notes?.name !== "" && (updatebody["pname"] = notes?.name);
            notes?.dob && notes?.dob !== "" && (updatebody["pdob"] = notes?.dob);
            notes?.place && notes?.place !== "" && (updatebody["place"] = notes?.place);

            updateNotes(updatebody)
                .then((res) => {
                    if (res?.status) {
                        toast.success(res?.data, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        SetNotes({ ...notes, get: true });
                        setEditNotes(true);
                    } else {
                        toast.error(res?.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    console.log("e.........:", e);
                    setLoading(false);
                    setEditNotes(false);
                });
                close();
        }
    };

    const handleTerms = (value) => {
        SetNotes({ ...notes, notes: value });
    };


    return (
        <div className="internalNoteSlider internalNoteSliderIn">
            {loading && <Loader />}
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>Internal Notes</span>
                    </div>
                    <div className="hdrActionGroup" onClick={close}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
            </div>
            <div className="flexCol">
                <div className="flexRow alignCntr">
                    <div className="flexAutuRow">
                        <div className="proCardAvtr">
                            <img src="/images/icons/doctor-default.png" alt="avatar" />
                        </div>
                    </div>
                    <div className="flexMinWidthRow">
                        <div className="flexWrap pdngXS">
                            <div className="oneFourthWidth flexInline pdngXXXS">
                                <div className="flexRow ">
                                    <div className="networkMinWidth  pdngHXS">
                                        <span className="headingSM ellipsisTxt">Name</span>
                                    </div>
                                    <div className="flexMinWidthRow  pdngHXS">
                                        : &nbsp;
                                        {!editBtn ? (
                                            <span className="capitalTxt lightTxt titleHeading headingSM ellipsisTxt">{notes?.name}</span>
                                        ) : (
                                            <TextField
                                                id="filled-hidden-label-small"
                                                defaultValue={notes?.name}
                                                size="small"
                                                onChange={(e) => SetNotes({ ...notes, name: e.target.value })}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="oneFourthWidth flexInline pdngXXXS">
                                <div className="flexRow">
                                    <div className="networkMinWidth  pdngHXS">
                                        <span className="headingSM ellipsisTxt">Meet ID</span>
                                    </div>
                                    <div className="flexMinWidthRow  pdngHXS">
                                        : &nbsp;{" "}
                                        <span className="capitalTxt lightTxt titleHeading headingSM ellipsisTxt">{notes?.meetId}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="oneFourthWidth flexInline pdngXXXS">
                                <div className="flexRow">
                                    <div className="networkMinWidth  pdngHXS">
                                        <span className="headingSM ellipsisTxt">DOB</span>
                                    </div>
                                    <div className="flexMinWidthRow  pdngHXS">
                                        : &nbsp;
                                        {!editBtn ? (
                                            <span className="capitalTxt lightTxt titleHeading headingSM ellipsisTxt">
                                                {(dateFormat(notes.dob) !== 'Invalid Date'?dateFormat(notes.dob):formattedDate)}
                                            </span>
                                        ) : (
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    inputVariant="standard"
                                                    className="pickerInput"
                                                    value={dateFormat(notes.dob) !== 'Invalid Date'?notes.dob:formattedDate}
                                                    onChange={(date) => SetNotes({ ...notes, dob: date })}
                                                    animateYearScrolling
                                                    placeholdertext="From Date"
                                                    format="dd/MM/yyyy"
                                                    size="small"
                                                />
                                            </MuiPickersUtilsProvider>
                                            // <TextField id="filled-hidden-label-small"
                                            //     defaultValue={notes?.dob} size="small"
                                            //     onChange={(e) => SetNotes({ ...notes, dob: e.target.value })}
                                            // />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="oneFourthWidth flexInline pdngXXXS">
                                <div className="flexRow">
                                    <div className="networkMinWidth  pdngHXS">
                                        <span className="headingSM ellipsisTxt">Place</span>
                                    </div>
                                    <div className="flexMinWidthRow  pdngHXS">
                                        : &nbsp;{" "}
                                        {!editBtn ? (
                                            <span className="capitalTxt lightTxt titleHeading headingSM ellipsisTxt">{notes?.place}</span>
                                        ) : (
                                            <TextField
                                                id="filled-hidden-label-small"
                                                defaultValue={notes?.place}
                                                size="small"
                                                onChange={(e) => SetNotes({ ...notes, place: e.target.value })}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flexRow justfiyEnd alignEnd pdngSM" onClick={() => setEditBtn(!editBtn)}>
                    {!editBtn ? (
                        <Tooltip title="edit">
                            {/* <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                                <Button buttonType="submit" label="save" type="primary" size="sm" onClick={handleSubmitData} /> */}
                            <Button variant="outlined" color="primary" size="small">
                                Edit
                            </Button>
                        </Tooltip>
                    ) : (
                        <>
                            <div className="pdngHXSM">
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    onClick={() =>
                                        SetNotes({
                                            ...notes,
                                            name: cancel?.name,
                                            dob: cancel?.dob,
                                            place: cancel?.place,
                                        })
                                    }
                                >
                                    cancel
                                </Button>
                            </div>
                            <Button
                                buttonType="submit"
                                variant="contained"
                                color="primary"
                                size="small"
                                className="whiteTxt"
                                onClick={handleSubmitData}
                            >
                                save
                            </Button>
                        </>
                    )}
                </div>
                <div className="flexMinHeightCol pdngXS">
                    <ReactQuillEditor
                        type="certificate"
                        placeholder="Terms & Conditions"
                        // readOnly={edit}
                        name="notes"
                        textData={notes?.notes}
                        setTextData={handleTerms}
                    />
                </div>
                <div className="flexRow justfiyEnd alignEnd pdngRSM">
                {editNotes === true ? <div className="pdngHXSM">
                        <Button variant="outlined" color="primary" size="small" onClick={() =>{
                             SetNotes({ ...notes, notes: "" })
                             setEditNotes(false);
                             }}>
                            Reset
                        </Button>
                    </div>: 
                    <Button
                        buttonType="submit"
                        variant="contained"
                        color="primary"
                        size="small"
                        className="whiteTxt"
                        onClick={handleSubmitData}
                    >
                        save
                    </Button> }
            </div> 
            </div>
        </div>
    );
};
export default InternalNote;
